import { render, staticRenderFns } from "./NewProductView.vue?vue&type=template&id=25250ac8&"
import script from "./NewProductView.vue?vue&type=script&lang=js&"
export * from "./NewProductView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports